import React from 'react'
import { createRoutes } from 'shared/hocs'

import { renderLoginTipsIfNotAuthenticated } from 'shared/hocs/authenticated'
import { Redirect } from 'react-router-dom'
import { profile } from 'routes/route.map'
import InWins from '../profile/inwins'
import TransHistoryBene from '../profile/transHistoryBene'
import transHistorySponsor from '../profile/transHistorySponsor'
import { Teams } from './teams'
import { Events } from './events'
import { Athletes } from './athletes'
import Tournaments from './tournaments'
import SplashScreen from './aboutUs'
import DataRemove from './dataRemove'
import PrivacyPolicy from './privacyPolicy'

import Layout from './shared/layout'

const PublicRoutes = createRoutes(
  ({ match }) => [
    {
      path: `${match.path}/tournaments`,
      component: Tournaments,
    },
    {
      path: `${match.path}/events`,
      component: renderLoginTipsIfNotAuthenticated(Events),
    },
    {
      path: `${match.path}/user-data-deletion-request`,
      component: DataRemove,
    },
    {
      path: `${match.path}/privacy-policy`,
      component: PrivacyPolicy,
    },
    {
      path: `${match.path}/athletes`,
      component: Athletes,
    },
    {
      path: `${match.path}/teams`,
      component: Teams,
    },
    {
      path: `${match.path}/inwins-history`,
      component: renderLoginTipsIfNotAuthenticated(InWins),
    },
    {
      path: `${match.path}/transactions-history-beneficiary`,
      component: renderLoginTipsIfNotAuthenticated(TransHistoryBene),
    },
    {
      path: `${match.path}/transactions-history-sponsor`,
      component: renderLoginTipsIfNotAuthenticated(transHistorySponsor),
    },
    {
      path: `${match.path}/profile`,
      component: renderLoginTipsIfNotAuthenticated(() => (
        <Redirect to={profile.index()} />
      )),
    },
    {
      exact: true,
      path: match.path,
      component: SplashScreen,
    },
  ],
  { layout: Layout }
)

export default PublicRoutes
